export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Legacy constants - now fetched from API but kept for fallback
export const SPECIALTIES_OPTIONS = ["Carne", "Pescado", "Brasa", "Tapas", "Arroces", "Pasta", "Asador", "Pizza", "Postres", "Sandwiches"];

export const CUISINE_TYPES = [
  "Andaluza",
  "Catalana",
  "China",
  "Colombiana",
  "Coreana",
  "Francesa",
  "Hamburguesas",
  "Italiana",
  "Japonesa",
  "Mediterranea",
  "Mexicana",
  "Peruana",
  "Tailandesa",
  "Tapas",
  "Vasca"
];
